import React from "react";
import styles from "./MyCards.module.css";

// icons
import { ReactComponent as BackIcon } from "./../../../assets/svg/back-icon.svg";
import { ReactComponent as ChipIcon } from "./../../../assets/svg/chip.svg";
import { ReactComponent as IncreaseIcon } from "./../../../assets/svg/increase.svg";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

const transactionsList = [
  {
    id: 1425234,
    isPayment: true,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: true,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: false,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: true,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: true,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: false,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: true,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: false,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: false,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
  {
    id: 1425234,
    isPayment: true,
    date: "Sunday 20 March 8-10 Am",
    price: "99",
  },
];

const MyCards = () => {
  const navigate = useLangNavigate();
  return (
    <div className={styles.MyCards}>
      <div className={styles.TopSection}>
        <div className={styles.Header}>
          <div className="flex justify-start items-center">
            <div
              onClick={() => navigate("/profile")}
              className={styles.BackIconContainer}
            >
              <BackIcon />
            </div>
            <span className={styles.HeaderTitle}>My Cards</span>
          </div>
        </div>
        <div className={styles.TopSectionContent}>
          <ChipIcon className={styles.ChipIcon} />
          <div className={styles.CardNumber}>
            <div>****</div>
            <div>****</div>
            <div>****</div>
            <div>1234</div>
          </div>

          <div
            style={{ fontSize: "18px" }}
            className="w-full flex justify-between items-center"
          >
            <div>01/22</div>
            <div>Mehran Sadeghi</div>
          </div>
          <div className={styles.Separator} />
          <div
            style={{ fontSize: "25px" }}
            className="w-full flex justify-between items-center mb-5"
          >
            <div style={{ fontSize: "18px" }}>Balance</div>
            <span>
              <span
                style={{
                  verticalAlign: "top",
                  fontSize: "18px",
                }}
              >
                OMR{" "}
              </span>
              <strong>6500</strong>
            </span>
          </div>
        </div>
        <div className={styles.FakeBottom} />
      </div>
      <div className={styles.BottomSection}>
        {/* <div className="w-full flex justify-between items-center">
                    <div className="grow flex justify-center items-center pe-1">
                        <div className={`${styles.LittleCard} ${styles.Green}`}>
                            <p>Used balance</p>
                            <span>
                                OMR <strong>200</strong>
                            </span>
                        </div>
                    </div>
                    <div className="grow flex justify-center items-center ps-1">
                        <div className={`${styles.LittleCard} ${styles.Red}`}>
                            <p>Used balance</p>
                            <span>
                                OMR <strong>1000</strong>
                            </span>
                        </div>
                    </div>
                </div> */}
        <p className={styles.BottomSectionTitle}>Transactions</p>
        {transactionsList.map((item) => {
          return (
            <div className={styles.Transaction}>
              <div
                className={`${styles.IconContainer} ${
                  !item.isPayment ? styles.Decrease : ""
                }`}
              >
                <IncreaseIcon />
              </div>
              <div className="grow flex flex-column justify-center items-start">
                <p className={styles.TransactionTitle}>
                  {item.isPayment ? "Payment" : "Order"} #{item.id}
                </p>
                <div className="w-full flex justify-between items-center pe-4">
                  <span className={styles.TransactionDate}>{item.date}</span>
                  <span className={styles.TransactionPrice}>
                    OMR <strong>{item.price}</strong>
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyCards;
